import React, { PropsWithChildren } from 'react';

import { useTheme } from '../hooks/theme';

import Header from './components/Header';
import Aside from './components/Aside';
import Content from './components/Content';

import { Grid } from './layout-styles';
import SupportFloatingBadge from '../components/SupportFloatingBadge';
import FloatingPeriodicTableButton from '../components/FloatingPeriodicTableButton';

const Layout: React.FC<PropsWithChildren> = ({ children }) => {
  const { theme } = useTheme();

  return (
    <>
      <Grid id="grid" style={theme === 'dark' ? {
        background: '#101426'
      } : { background: '#ffffff' }}>
        <Header />
        <Aside />
        <Content>
          {children}
        </Content>
        <FloatingPeriodicTableButton />
        <SupportFloatingBadge />
      </Grid>
    </>
  );
}

export default Layout;